import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { UPDATE_NOMBRE_PACIENTE } from "../../../../data/graphQL/mutations/SoporteHC/paciente";
import { useMutationHandler } from "../../hooks/useMutationHandler";

export default function CambiarNombrePacienteForm() {
    const inputFields = [
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC Paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
        {
            name: 'nombre',
            type: 'string',
            displayName: 'Nombre',
            size: 2,
            required: true,
            placeholder: 'Ingrese Nuevo nombre'
        },
        {
            name: 'apellido',
            type: 'string',
            displayName: 'Apellido',
            size: 2,
            required: true,
            placeholder: 'Ingrese nuevo apellido',
        }
    ];

    const { values, handleChange, handleSubmit, loading } =
        useMutationHandler({
            initialValues: {
                idPaciente: '',
                nombre: '',
                apellido: ''
            },
            mutation: UPDATE_NOMBRE_PACIENTE,
            onSuccess: (data) => {
                if (data.updateNombrePaciente.error) {
                    toast.error(data.updateNombrePaciente.error);
                }

                if (data.updateNombrePaciente.success)
                    toast.success('El nombre del paciente se actualizó correctamente.');
            }
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
